// extracted by mini-css-extract-plugin
export default {"home":"home_home__y8EdM","leftBackground":"home_leftBackground__kXN3J","secondSectionContainer":"home_secondSectionContainer__sFQOu"};